// CSDL Cẩm Nang Nghiên Cứu Khai Cục & Cạm Bẫy Toàn Tập (10+ Hệ Thống Lớn)
// Tự động đồng bộ chuẩn 100% với Động Cơ Cờ Tướng Conic

export const OPENING_TRAP_MASTER_DATABASE = [
  {
    "id": "binh-phong-ma",
    "folder": "01. Trung Pháo Đối Bình Phong Mã (Đỉnh Cao Đối Kháng)",
    "name": "Trung Pháo Đối Bình Phong Mã",
    "cn": "中炮对屏风马",
    "overview": "Đỉnh cao đối kháng nghệ thuật cờ tướng đỉnh cao. Trung Pháo cương mãnh tấn công trung lộ, Bình Phong Mã nhu hòa kiên cố, hai Mã kẹp sườn thủ chặt trung cung, hai Pháo linh hoạt cơ động phản đòn.",
    "maxim": "Pháo đầu quá hà xe tiến công, Bình Phong Mã nhảy giữ trung cung.\nTả pháo phong xe triệt lộ tiến, hữu mã bàn hà phục bão bùng.\nNếu địch tham ăn đè mã lộ, phế mã hãm xe đoạt kỳ phong!",
    "strategicKey": "Kiểm soát trục lộ 3 và lộ 7, ngăn Xe Đỏ phong tỏa sườn, tận dụng Tả Pháo phong xe và Hữu Mã bàn hà đột phá.",
    "subtypes": [
      "Bình Phong Mã Tốt 7 (Thất Lộ Mã)",
      "Bình Phong Mã Tốt 3 (Tam Lộ Mã)",
      "Bình Phong Mã Bình Pháo Đổi Xe",
      "Bình Phong Mã Tả Mã Bàn Hà",
      "Trung Pháo Cấp Tấn Trung Binh",
      "Ngũ Lục Pháo & Ngũ Thất Pháo Đối Bình Phong Mã"
    ],
    "lessonCount": 829,
    "traps": [
      {
        "trapId": "featured_binh-phong-ma_1",
        "lessonId": "op_binh-phong-ma_1_cb14d9",
        "name": "Bình Phong Mã Căn Bản Đối Pháo Đầu - Biến 1",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 4,
            "red": "车二进六",
            "red_vi": "Xe 2 tiến 6",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 5,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "马７进６",
            "black_vi": "Mã 7 tiến 6"
          },
          {
            "num": 6,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "车１进１",
            "black_vi": "Xe 1 tiến 1"
          },
          {
            "num": 7,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 8,
            "red": "车二平四",
            "red_vi": "Xe 2 bình 4",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 9,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 10,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          }
        ],
        "movesSummary": "1. 炮二平五 马８进７ 2. 马二进三 车９平８ 3. 车一平二 卒７进１ 4. 车二进六 马２进３ 5. 兵七进一 马７进６ 6. 马八进七 车１进１ 7. 兵五进一 卒７进１",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_binh-phong-ma_2",
        "lessonId": "op_binh-phong-ma_2_d51dc6",
        "name": "Bình Phong Mã Căn Bản Đối Pháo Đầu - Biến 2",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 4,
            "red": "车二进六",
            "red_vi": "Xe 2 tiến 6",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 5,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 6,
            "red": "车九进一",
            "red_vi": "Xe 9 tiến 1",
            "black": "象３进５",
            "black_vi": "Tượng 3 tiến 5"
          },
          {
            "num": 7,
            "red": "车九平六",
            "red_vi": "Xe 9 bình 6",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          },
          {
            "num": 8,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "炮２进４",
            "black_vi": "Pháo 2 tiến 4"
          },
          {
            "num": 9,
            "red": "炮五进一",
            "red_vi": "Pháo 5 tiến 1",
            "black": "炮２退２",
            "black_vi": "Pháo 2 thoái 2"
          },
          {
            "num": 10,
            "red": "车二平三",
            "red_vi": "Xe 2 bình 3",
            "black": "炮８进５",
            "black_vi": "Pháo 8 tiến 5"
          }
        ],
        "movesSummary": "1. 炮二平五 马８进７ 2. 马二进三 车９平８ 3. 车一平二 卒７进１ 4. 车二进六 马２进３ 5. 马八进七 卒３进１ 6. 车九进一 象３进５ 7. 车九平六 士４进５",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_binh-phong-ma_3",
        "lessonId": "op_binh-phong-ma_3_ba0afe",
        "name": "Bình Phong Mã Căn Bản Đối Pháo Đầu - Biến 3",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 4,
            "red": "车二进六",
            "red_vi": "Xe 2 tiến 6",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 5,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 6,
            "red": "车九进一",
            "red_vi": "Xe 9 tiến 1",
            "black": "象３进５",
            "black_vi": "Tượng 3 tiến 5"
          },
          {
            "num": 7,
            "red": "车九平六",
            "red_vi": "Xe 9 bình 6",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          },
          {
            "num": 8,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "炮２进４",
            "black_vi": "Pháo 2 tiến 4"
          },
          {
            "num": 9,
            "red": "炮五进一",
            "red_vi": "Pháo 5 tiến 1",
            "black": "炮２退２",
            "black_vi": "Pháo 2 thoái 2"
          },
          {
            "num": 10,
            "red": "车二平三",
            "red_vi": "Xe 2 bình 3",
            "black": "炮８进５",
            "black_vi": "Pháo 8 tiến 5"
          }
        ],
        "movesSummary": "1. 炮二平五 马８进７ 2. 马二进三 车９平８ 3. 车一平二 卒７进１ 4. 车二进六 马２进３ 5. 马八进七 卒３进１ 6. 车九进一 象３进５ 7. 车九平六 士４进５",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      }
    ]
  },
  {
    "id": "thuan-phao",
    "folder": "02. Thuận Thủ Pháo (Đại Chiến Công Tâm)",
    "name": "Thuận Thủ Pháo (Thuận Pháo)",
    "cn": "顺手炮",
    "overview": "Đại chiến công đối công kịch tính bậc nhất. Hai bên cùng vào Pháo đầu cùng chiều, tranh nhau xuất Xe chiếm lộ hiểm. Một bên đánh đòn phủ đầu, một bên phản kích trực diện vào trung tâm.",
    "maxim": "Thuận Pháo hoành xa phá trực xa, tiên thủ đắc lợi chiếm hà pha.\nChớ tham đè mã lâm nguy hiểm, cẩn thận quá cung phục sát hoa.\nPháo đầu mã đội uy phong lớn, chậm bước một ly tan cửa nhà!",
    "strategicKey": "Tốc độ xuất Xe là sinh tử. Hoành Xe khống chế sườn lộ 4-6, Trực Xe kiểm soát tuần hà. Tuyệt đối không để Pháo đối phương rảnh tay chém Tốt đầu.",
    "subtypes": [
      "Thuận Pháo Hoành Xa Đối Trực Xa",
      "Thuận Pháo Trực Xa Đối Hoành Xa",
      "Thuận Pháo Hoành Xa Đối Hoành Xa",
      "Thuận Pháo Hoãn Khai Xe",
      "Thuận Pháo Khí Mã Tranh Tiên"
    ],
    "lessonCount": 48,
    "traps": [
      {
        "trapId": "featured_thuan-phao_1",
        "lessonId": "op_thuan-phao_1_6e57d1",
        "name": "Đại Thuận Thủ Pháo Công Thủ Toàn Thư - Biến 1",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "炮８平５",
            "black_vi": "Pháo 8 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 4,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "车９平４",
            "black_vi": "Xe 9 bình 4"
          },
          {
            "num": 5,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "车４进４",
            "black_vi": "Xe 4 tiến 4"
          },
          {
            "num": 6,
            "red": "炮五平四",
            "red_vi": "Pháo 5 bình 4",
            "black": "卒５进１",
            "black_vi": "Tốt 5 tiến 1"
          },
          {
            "num": 7,
            "red": "相七进五",
            "red_vi": "Tượng 7 tiến 5",
            "black": "卒５进１",
            "black_vi": "Tốt 5 tiến 1"
          },
          {
            "num": 8,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "车４进１",
            "black_vi": "Xe 4 tiến 1"
          },
          {
            "num": 9,
            "red": "仕六进五",
            "red_vi": "Sĩ 6 tiến 5",
            "black": "卒５进１",
            "black_vi": "Tốt 5 tiến 1"
          },
          {
            "num": 10,
            "red": "马三进四",
            "red_vi": "Mã 3 tiến 4",
            "black": "车４平２",
            "black_vi": "Xe 4 bình 2"
          }
        ],
        "movesSummary": "1. 炮二平五 炮８平５ 2. 马二进三 马８进７ 3. 车一平二 车９进１ 4. 兵三进一 车９平４ 5. 马八进七 车４进４ 6. 炮五平四 卒５进１ 7. 相七进五 卒５进１",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_thuan-phao_2",
        "lessonId": "op_thuan-phao_2_130a71",
        "name": "Đại Thuận Thủ Pháo Công Thủ Toàn Thư - Biến 2",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "炮８平５",
            "black_vi": "Pháo 8 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 4,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "车９平４",
            "black_vi": "Xe 9 bình 4"
          },
          {
            "num": 5,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "车４进４",
            "black_vi": "Xe 4 tiến 4"
          },
          {
            "num": 6,
            "red": "炮五平四",
            "red_vi": "Pháo 5 bình 4",
            "black": "车４平７",
            "black_vi": "Xe 4 bình 7"
          },
          {
            "num": 7,
            "red": "车二进二",
            "red_vi": "Xe 2 tiến 2",
            "black": "炮２平４",
            "black_vi": "Pháo 2 bình 4"
          },
          {
            "num": 8,
            "red": "相七进五",
            "red_vi": "Tượng 7 tiến 5",
            "black": "车７退１",
            "black_vi": "Xe 7 thoái 1"
          },
          {
            "num": 9,
            "red": "炮八退一",
            "red_vi": "Pháo 8 thoái 1",
            "black": "车７平６",
            "black_vi": "Xe 7 bình 6"
          },
          {
            "num": 10,
            "red": "仕六进五",
            "red_vi": "Sĩ 6 tiến 5",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          }
        ],
        "movesSummary": "1. 炮二平五 炮８平５ 2. 马二进三 马８进７ 3. 车一平二 车９进１ 4. 兵三进一 车９平４ 5. 马八进七 车４进４ 6. 炮五平四 车４平７ 7. 车二进二 炮２平４",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_thuan-phao_3",
        "lessonId": "op_thuan-phao_3_09ee1c",
        "name": "Đại Thuận Thủ Pháo Công Thủ Toàn Thư - Biến 3",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "炮８平５",
            "black_vi": "Pháo 8 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 4,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "车９平４",
            "black_vi": "Xe 9 bình 4"
          },
          {
            "num": 5,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "车４进５",
            "black_vi": "Xe 4 tiến 5"
          },
          {
            "num": 6,
            "red": "炮五平四",
            "red_vi": "Pháo 5 bình 4",
            "black": "卒５进１",
            "black_vi": "Tốt 5 tiến 1"
          },
          {
            "num": 7,
            "red": "相七进五",
            "red_vi": "Tượng 7 tiến 5",
            "black": "卒５进１",
            "black_vi": "Tốt 5 tiến 1"
          },
          {
            "num": 8,
            "red": "炮四进一",
            "red_vi": "Pháo 4 tiến 1",
            "black": "车４进２",
            "black_vi": "Xe 4 tiến 2"
          },
          {
            "num": 9,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 10,
            "red": "仕六进五",
            "red_vi": "Sĩ 6 tiến 5",
            "black": "马３进５",
            "black_vi": "Mã 3 tiến 5"
          }
        ],
        "movesSummary": "1. 炮二平五 炮８平５ 2. 马二进三 马８进７ 3. 车一平二 车９进１ 4. 兵三进一 车９平４ 5. 马八进七 车４进５ 6. 炮五平四 卒５进１ 7. 相七进五 卒５进１",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      }
    ]
  },
  {
    "id": "nghich-phao",
    "folder": "03. Nghịch Thủ Pháo & Liệt Pháo (Sát Khí Nghịch Chuyển)",
    "name": "Nghịch Thủ Pháo & Liệt Pháo",
    "cn": "逆手炮与列炮",
    "overview": "Thế trận sinh tử một mất một còn. Hai Pháo đối xứng ngược chiều, phá vỡ thế cân bằng ngay từ nước đầu. Khuyết Sĩ gãy Tượng là điều thường thấy, thắng thua định đoạt trong chớp mắt.",
    "maxim": "Liệt Pháo công tâm sát khí nồng, đôi bên quyết tử chẳng khoan nhượng.\nQuất Trung Bí truyền mưu khí tượng, hãm xe góc chết rạng kỳ phong.\nThủ vững trung tâm phòng pháo kích, xuất xe chậm trễ ắt vùi thây!",
    "strategicKey": "Mục tiêu tối thượng là công phá Tượng đáy và xông thẳng vào Cung Tướng. Bên nào chiếm được thế chủ động chiếu trước sẽ giành thắng lợi thần tốc.",
    "subtypes": [
      "Tiểu Liệt Thủ Pháo Khí Tượng Hãm Xe",
      "Đại Liệt Thủ Pháo Pháo Chém Tượng",
      "Bán Đồ Nghịch Pháo (Nửa Đường Đổi Trận)",
      "Nghịch Pháo Tiến Mã Khí Binh"
    ],
    "lessonCount": 106,
    "traps": [
      {
        "trapId": "featured_nghich-phao_1",
        "lessonId": "op_nghich-phao_1_ae1eb2",
        "name": "Nghịch Thủ Pháo & Liệt Pháo Toàn Thư - Biến 1",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "炮２平５",
            "black_vi": "Pháo 2 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 4,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 5,
            "red": "马八进九",
            "red_vi": "Mã 8 tiến 9",
            "black": "车１平２",
            "black_vi": "Xe 1 bình 2"
          },
          {
            "num": 6,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "车２进５",
            "black_vi": "Xe 2 tiến 5"
          },
          {
            "num": 7,
            "red": "车二进四",
            "red_vi": "Xe 2 tiến 4",
            "black": "炮８平９",
            "black_vi": "Pháo 8 bình 9"
          },
          {
            "num": 8,
            "red": "炮八平七",
            "red_vi": "Pháo 8 bình 7",
            "black": "车２进４",
            "black_vi": "Xe 2 tiến 4"
          },
          {
            "num": 9,
            "red": "车二进五",
            "red_vi": "Xe 2 tiến 5",
            "black": "车２平３",
            "black_vi": "Xe 2 bình 3"
          },
          {
            "num": 10,
            "red": "炮七进四",
            "red_vi": "Pháo 7 tiến 4",
            "black": "马７退８",
            "black_vi": "Mã 7 thoái 8"
          }
        ],
        "movesSummary": "1. 炮二平五 炮２平５ 2. 马二进三 马８进７ 3. 车一平二 车９平８ 4. 兵三进一 马２进３ 5. 马八进九 车１平２ 6. 车九平八 车２进５ 7. 车二进四 炮８平９",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_nghich-phao_2",
        "lessonId": "op_nghich-phao_2_fae763",
        "name": "Nghịch Thủ Pháo & Liệt Pháo Toàn Thư - Biến 2",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "炮２平５",
            "black_vi": "Pháo 2 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 4,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 5,
            "red": "马八进九",
            "red_vi": "Mã 8 tiến 9",
            "black": "车１平２",
            "black_vi": "Xe 1 bình 2"
          },
          {
            "num": 6,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "车２进５",
            "black_vi": "Xe 2 tiến 5"
          },
          {
            "num": 7,
            "red": "车二进四",
            "red_vi": "Xe 2 tiến 4",
            "black": "炮８平９",
            "black_vi": "Pháo 8 bình 9"
          },
          {
            "num": 8,
            "red": "炮八平七",
            "red_vi": "Pháo 8 bình 7",
            "black": "车２进４",
            "black_vi": "Xe 2 tiến 4"
          },
          {
            "num": 9,
            "red": "车二进五",
            "red_vi": "Xe 2 tiến 5",
            "black": "车２平３",
            "black_vi": "Xe 2 bình 3"
          },
          {
            "num": 10,
            "red": "炮七进四",
            "red_vi": "Pháo 7 tiến 4",
            "black": "车３平１",
            "black_vi": "Xe 3 bình 1"
          }
        ],
        "movesSummary": "1. 炮二平五 炮２平５ 2. 马二进三 马８进７ 3. 车一平二 车９平８ 4. 兵三进一 马２进３ 5. 马八进九 车１平２ 6. 车九平八 车２进５ 7. 车二进四 炮８平９",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_nghich-phao_3",
        "lessonId": "op_nghich-phao_3_12682e",
        "name": "Nghịch Thủ Pháo & Liệt Pháo Toàn Thư - Biến 3",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "炮２平５",
            "black_vi": "Pháo 2 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 4,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 5,
            "red": "马八进九",
            "red_vi": "Mã 8 tiến 9",
            "black": "车１平２",
            "black_vi": "Xe 1 bình 2"
          },
          {
            "num": 6,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "车２进５",
            "black_vi": "Xe 2 tiến 5"
          },
          {
            "num": 7,
            "red": "车二进四",
            "red_vi": "Xe 2 tiến 4",
            "black": "炮８平９",
            "black_vi": "Pháo 8 bình 9"
          },
          {
            "num": 8,
            "red": "炮八平七",
            "red_vi": "Pháo 8 bình 7",
            "black": "车２进４",
            "black_vi": "Xe 2 tiến 4"
          },
          {
            "num": 9,
            "red": "车二进五",
            "red_vi": "Xe 2 tiến 5",
            "black": "马７退８",
            "black_vi": "Mã 7 thoái 8"
          },
          {
            "num": 10,
            "red": "马九退八",
            "red_vi": "Mã 9 thoái 8",
            "black": "",
            "black_vi": ""
          }
        ],
        "movesSummary": "1. 炮二平五 炮２平５ 2. 马二进三 马８进７ 3. 车一平二 车９平８ 4. 兵三进一 马２进３ 5. 马八进九 车１平２ 6. 车九平八 车２进５ 7. 车二进四 炮８平９",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      }
    ]
  },
  {
    "id": "phan-cung-ma",
    "folder": "04. Trung Pháo Đối Phản Cung Mã (Nhu Khắc Cương)",
    "name": "Trung Pháo Đối Phản Cung Mã (Nửa Vầng Trăng)",
    "cn": "中炮对反宫马",
    "overview": "Thế trận Nhu Thắng Cương nổi tiếng của danh thủ Hồ Vinh Hoa. Một Mã giữ trung tâm, một Mã nhảy ra biên, Sĩ Tượng hỗ trợ phòng ngự vững chắc, dùng Song Pháo quá hà phản công sấm sét.",
    "maxim": "Phản Cung Mã trận biến khôn lường, hai pháo kẹp sườn thủ bốn phương.\nSĩ tượng kiên cố chờ cơ hội, song pháo quá hà phá kỷ cương.\nPháo đầu muốn phá công sườn yếu, chớ đánh vội vàng dễ tổn thương!",
    "strategicKey": "Phòng thủ kín kẽ trung lộ, biến điểm yếu Mã biên thành bàn đạp phóng Pháo qua sông kiềm tỏa Xe Mã đối phương.",
    "subtypes": [
      "Phản Cung Mã Tiến Tốt 3",
      "Phản Cung Mã Tiến Tốt 7",
      "Phản Cung Mã Song Pháo Quá Hà Phản Kích",
      "Trung Pháo Ép Mã Biên Phản Cung"
    ],
    "lessonCount": 126,
    "traps": [
      {
        "trapId": "featured_phan-cung-ma_1",
        "lessonId": "op_phan-cung-ma_1_05bd16",
        "name": "Phản Cung Mã Nhu Khắc Cương Toàn Tập - Biến 1",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "炮８平６",
            "black_vi": "Pháo 8 bình 6"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 4,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 5,
            "red": "马八进九",
            "red_vi": "Mã 8 tiến 9",
            "black": "象７进５",
            "black_vi": "Tượng 7 tiến 5"
          },
          {
            "num": 6,
            "red": "炮八平七",
            "red_vi": "Pháo 8 bình 7",
            "black": "车１平２",
            "black_vi": "Xe 1 bình 2"
          },
          {
            "num": 7,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "炮２进４",
            "black_vi": "Pháo 2 tiến 4"
          },
          {
            "num": 8,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 9,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 10,
            "red": "车二进四",
            "red_vi": "Xe 2 tiến 4",
            "black": "卒３平２",
            "black_vi": "Tốt 3 bình 2"
          }
        ],
        "movesSummary": "1. 炮二平五 马２进３ 2. 马二进三 炮８平６ 3. 车一平二 马８进７ 4. 兵三进一 卒３进１ 5. 马八进九 象７进５ 6. 炮八平七 车１平２ 7. 车九平八 炮２进４",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_phan-cung-ma_2",
        "lessonId": "op_phan-cung-ma_2_d47bf8",
        "name": "Phản Cung Mã Nhu Khắc Cương Toàn Tập - Biến 2",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "炮８平６",
            "black_vi": "Pháo 8 bình 6"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 4,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 5,
            "red": "马八进九",
            "red_vi": "Mã 8 tiến 9",
            "black": "象７进５",
            "black_vi": "Tượng 7 tiến 5"
          },
          {
            "num": 6,
            "red": "炮八平七",
            "red_vi": "Pháo 8 bình 7",
            "black": "车１平２",
            "black_vi": "Xe 1 bình 2"
          },
          {
            "num": 7,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "炮２进４",
            "black_vi": "Pháo 2 tiến 4"
          },
          {
            "num": 8,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 9,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 10,
            "red": "车二进四",
            "red_vi": "Xe 2 tiến 4",
            "black": "卒３平２",
            "black_vi": "Tốt 3 bình 2"
          }
        ],
        "movesSummary": "1. 炮二平五 马２进３ 2. 马二进三 炮８平６ 3. 车一平二 马８进７ 4. 兵三进一 卒３进１ 5. 马八进九 象７进５ 6. 炮八平七 车１平２ 7. 车九平八 炮２进４",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_phan-cung-ma_3",
        "lessonId": "op_phan-cung-ma_3_8f2e4b",
        "name": "Phản Cung Mã Nhu Khắc Cương Toàn Tập - Biến 3",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "炮８平６",
            "black_vi": "Pháo 8 bình 6"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 4,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 5,
            "red": "马八进九",
            "red_vi": "Mã 8 tiến 9",
            "black": "象７进５",
            "black_vi": "Tượng 7 tiến 5"
          },
          {
            "num": 6,
            "red": "炮八平七",
            "red_vi": "Pháo 8 bình 7",
            "black": "车１平２",
            "black_vi": "Xe 1 bình 2"
          },
          {
            "num": 7,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "炮２进４",
            "black_vi": "Pháo 2 tiến 4"
          },
          {
            "num": 8,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 9,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 10,
            "red": "车二进四",
            "red_vi": "Xe 2 tiến 4",
            "black": "炮２平３",
            "black_vi": "Pháo 2 bình 3"
          }
        ],
        "movesSummary": "1. 炮二平五 马２进３ 2. 马二进三 炮８平６ 3. 车一平二 马８进７ 4. 兵三进一 卒３进１ 5. 马八进九 象７进５ 6. 炮八平七 车１平２ 7. 车九平八 炮２进４",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      }
    ]
  },
  {
    "id": "don-de-ma",
    "folder": "05. Trung Pháo Đối Đơn Đề Mã (Biến Ảo Khó Lường)",
    "name": "Trung Pháo Đối Đơn Đề Mã",
    "cn": "中炮对单提马",
    "overview": "Thế trận độc đáo bất đối xứng. Một Mã lên chính diện giữ Tốt đầu, một Mã ra biên hoặc nhảy quỳ. Đơn Đề Mã thường kết hợp Hoành Xe quá cung tạo cạm bẫy bắt sống Xe đối phương.",
    "maxim": "Đơn Đề Mã trận tựa rồng nghiêng, một mã giữ cung một mã biên.\nHoành xe quá cung giăng bẫy hiểm, xe địch vào sâu chết chẳng phiền.\nCông phá Đơn Đề đè mã yếu, chớ để hoành xe chiếm lộ tiền!",
    "strategicKey": "Lừa đối phương cấp tiến Xe vào sâu đè Mã, sau đó dùng Pháo biên và Mã thoái bắt chết Xe.",
    "subtypes": [
      "Tả Đơn Đề Mã Hoành Xe Quá Cung",
      "Hữu Đơn Đề Mã Bẫy Kẹt Tượng",
      "Đơn Đề Mã Phế Tốt Phản Kích Cánh Yếu"
    ],
    "lessonCount": 107,
    "traps": [
      {
        "trapId": "featured_don-de-ma_1",
        "lessonId": "op_don-de-ma_1_69c0eb",
        "name": "Đơn Đề Mã Biến Ảo Khó Lường - Biến 1",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进９",
            "black_vi": "Mã 8 tiến 9"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 4,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "象３进５",
            "black_vi": "Tượng 3 tiến 5"
          },
          {
            "num": 5,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          },
          {
            "num": 6,
            "red": "炮八平九",
            "red_vi": "Pháo 8 bình 9",
            "black": "炮２进４",
            "black_vi": "Pháo 2 tiến 4"
          },
          {
            "num": 7,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "车１平４",
            "black_vi": "Xe 1 bình 4"
          },
          {
            "num": 8,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "炮２平３",
            "black_vi": "Pháo 2 bình 3"
          },
          {
            "num": 9,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "车４进６",
            "black_vi": "Xe 4 tiến 6"
          },
          {
            "num": 10,
            "red": "兵九进一",
            "red_vi": "Binh 9 tiến 1",
            "black": "车４平７",
            "black_vi": "Xe 4 bình 7"
          }
        ],
        "movesSummary": "1. 炮二平五 马２进３ 2. 马二进三 马８进９ 3. 车一平二 车９平８ 4. 兵七进一 象３进５ 5. 马八进七 士４进５ 6. 炮八平九 炮２进４ 7. 兵三进一 车１平４",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_don-de-ma_2",
        "lessonId": "op_don-de-ma_2_3ce8cc",
        "name": "Đơn Đề Mã Biến Ảo Khó Lường - Biến 2",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进９",
            "black_vi": "Mã 8 tiến 9"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 4,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "象３进５",
            "black_vi": "Tượng 3 tiến 5"
          },
          {
            "num": 5,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          },
          {
            "num": 6,
            "red": "炮八平九",
            "red_vi": "Pháo 8 bình 9",
            "black": "炮２进４",
            "black_vi": "Pháo 2 tiến 4"
          },
          {
            "num": 7,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "车１平４",
            "black_vi": "Xe 1 bình 4"
          },
          {
            "num": 8,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "炮２平３",
            "black_vi": "Pháo 2 bình 3"
          },
          {
            "num": 9,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "炮８进４",
            "black_vi": "Pháo 8 tiến 4"
          },
          {
            "num": 10,
            "red": "仕六进五",
            "red_vi": "Sĩ 6 tiến 5",
            "black": "车４进６",
            "black_vi": "Xe 4 tiến 6"
          }
        ],
        "movesSummary": "1. 炮二平五 马２进３ 2. 马二进三 马８进９ 3. 车一平二 车９平８ 4. 兵七进一 象３进５ 5. 马八进七 士４进５ 6. 炮八平九 炮２进４ 7. 兵三进一 车１平４",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_don-de-ma_3",
        "lessonId": "op_don-de-ma_3_b48c70",
        "name": "Đơn Đề Mã Biến Ảo Khó Lường - Biến 3",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进９",
            "black_vi": "Mã 8 tiến 9"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 4,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "象３进５",
            "black_vi": "Tượng 3 tiến 5"
          },
          {
            "num": 5,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          },
          {
            "num": 6,
            "red": "炮八平九",
            "red_vi": "Pháo 8 bình 9",
            "black": "炮２进４",
            "black_vi": "Pháo 2 tiến 4"
          },
          {
            "num": 7,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "车１平４",
            "black_vi": "Xe 1 bình 4"
          },
          {
            "num": 8,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "车４进６",
            "black_vi": "Xe 4 tiến 6"
          },
          {
            "num": 9,
            "red": "车二进五",
            "red_vi": "Xe 2 tiến 5",
            "black": "炮８平６",
            "black_vi": "Pháo 8 bình 6"
          },
          {
            "num": 10,
            "red": "车二平八",
            "red_vi": "Xe 2 bình 8",
            "black": "炮２平３",
            "black_vi": "Pháo 2 bình 3"
          }
        ],
        "movesSummary": "1. 炮二平五 马２进３ 2. 马二进三 马８进９ 3. 车一平二 车９平８ 4. 兵七进一 象３进５ 5. 马八进七 士４进５ 6. 炮八平九 炮２进４ 7. 兵三进一 车１平４",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      }
    ]
  },
  {
    "id": "phi-tuong",
    "folder": "06. Phi Tượng Cuộc (Vững Như Thái Sơn)",
    "name": "Phi Tượng Cuộc (Tượng Khai Độc Nhất)",
    "cn": "飞相局",
    "overview": "Khai cục thủ chắc công sâu danh bất hư truyền của Kỳ Thánh Hồ Vinh Hoa. Nước đầu lên Tượng củng cố trung lộ, che chắn cung tướng rồi tùy biến đối phó với mọi trận hình của đối phương.",
    "maxim": "Phi Tượng khai đài thế vững vàng, dĩ nhu khắc cương trấn bốn bang.\nTrung tâm kiên cố phòng pháo kích, hai cánh linh hoạt đón xe sang.\nĐịch vội quá hà sa bẫy rập, bắt sống chiến xa rạng vẻ vang!",
    "strategicKey": "Không vội tấn công, dử đối phương nôn nóng xuất quân rồi dùng đòn vây ráp, khóa chặt quân xâm nhập.",
    "subtypes": [
      "Phi Tượng Đối Trung Pháo",
      "Phi Tượng Đối Quá Cung Pháo",
      "Phi Tượng Đối Tiến Tốt (Đối Binh Cuộc)",
      "Phi Tượng Vây Bắt Xe Quá Hà"
    ],
    "lessonCount": 201,
    "traps": [
      {
        "trapId": "featured_phi-tuong_1",
        "lessonId": "op_phi-tuong_1_37e000",
        "name": "Tuyệt Kỹ Phá Phi Tượng Cuộc - Biến 1",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "相三进五",
            "red_vi": "Tượng 3 tiến 5",
            "black": "炮８平５",
            "black_vi": "Pháo 8 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 4,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 5,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "炮２平３",
            "black_vi": "Pháo 2 bình 3"
          },
          {
            "num": 6,
            "red": "马七进八",
            "red_vi": "Mã 7 tiến 8",
            "black": "马７进６",
            "black_vi": "Mã 7 tiến 6"
          },
          {
            "num": 7,
            "red": "仕四进五",
            "red_vi": "Sĩ 4 tiến 5",
            "black": "马６进５",
            "black_vi": "Mã 6 tiến 5"
          },
          {
            "num": 8,
            "red": "炮二平一",
            "red_vi": "Pháo 2 bình 1",
            "black": "车８进９",
            "black_vi": "Xe 8 tiến 9"
          },
          {
            "num": 9,
            "red": "马三退二",
            "red_vi": "Mã 3 thoái 2",
            "black": "炮３退１",
            "black_vi": "Pháo 3 thoái 1"
          },
          {
            "num": 10,
            "red": "车九进一",
            "red_vi": "Xe 9 tiến 1",
            "black": "马２进１",
            "black_vi": "Mã 2 tiến 1"
          }
        ],
        "movesSummary": "1. 相三进五 炮８平５ 2. 马二进三 马８进７ 3. 车一平二 车９平８ 4. 马八进七 卒７进１ 5. 兵七进一 炮２平３ 6. 马七进八 马７进６ 7. 仕四进五 马６进５",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_phi-tuong_2",
        "lessonId": "op_phi-tuong_2_898028",
        "name": "Tuyệt Kỹ Phá Phi Tượng Cuộc - Biến 2",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "相三进五",
            "red_vi": "Tượng 3 tiến 5",
            "black": "炮８平５",
            "black_vi": "Pháo 8 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 4,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 5,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "炮２平３",
            "black_vi": "Pháo 2 bình 3"
          },
          {
            "num": 6,
            "red": "马七进八",
            "red_vi": "Mã 7 tiến 8",
            "black": "马７进６",
            "black_vi": "Mã 7 tiến 6"
          },
          {
            "num": 7,
            "red": "仕四进五",
            "red_vi": "Sĩ 4 tiến 5",
            "black": "马６进５",
            "black_vi": "Mã 6 tiến 5"
          },
          {
            "num": 8,
            "red": "炮二平一",
            "red_vi": "Pháo 2 bình 1",
            "black": "车８进９",
            "black_vi": "Xe 8 tiến 9"
          },
          {
            "num": 9,
            "red": "马三退二",
            "red_vi": "Mã 3 thoái 2",
            "black": "炮３退１",
            "black_vi": "Pháo 3 thoái 1"
          },
          {
            "num": 10,
            "red": "车九进一",
            "red_vi": "Xe 9 tiến 1",
            "black": "马２进１",
            "black_vi": "Mã 2 tiến 1"
          }
        ],
        "movesSummary": "1. 相三进五 炮８平５ 2. 马二进三 马８进７ 3. 车一平二 车９平８ 4. 马八进七 卒７进１ 5. 兵七进一 炮２平３ 6. 马七进八 马７进６ 7. 仕四进五 马６进５",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_phi-tuong_3",
        "lessonId": "op_phi-tuong_3_92532f",
        "name": "Tuyệt Kỹ Phá Phi Tượng Cuộc - Biến 3",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "相三进五",
            "red_vi": "Tượng 3 tiến 5",
            "black": "炮８平５",
            "black_vi": "Pháo 8 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 4,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 5,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "炮２平３",
            "black_vi": "Pháo 2 bình 3"
          },
          {
            "num": 6,
            "red": "马七进八",
            "red_vi": "Mã 7 tiến 8",
            "black": "马７进６",
            "black_vi": "Mã 7 tiến 6"
          },
          {
            "num": 7,
            "red": "仕四进五",
            "red_vi": "Sĩ 4 tiến 5",
            "black": "马６进５",
            "black_vi": "Mã 6 tiến 5"
          },
          {
            "num": 8,
            "red": "炮二平一",
            "red_vi": "Pháo 2 bình 1",
            "black": "车８进９",
            "black_vi": "Xe 8 tiến 9"
          },
          {
            "num": 9,
            "red": "马三退二",
            "red_vi": "Mã 3 thoái 2",
            "black": "炮３退１",
            "black_vi": "Pháo 3 thoái 1"
          },
          {
            "num": 10,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          }
        ],
        "movesSummary": "1. 相三进五 炮８平５ 2. 马二进三 马８进７ 3. 车一平二 车９平８ 4. 马八进七 卒７进１ 5. 兵七进一 炮２平３ 6. 马七进八 马７进６ 7. 仕四进五 马６进５",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      }
    ]
  },
  {
    "id": "tien-nhan",
    "folder": "07. Tiên Nhân Chỉ Lộ (Mở Đường Dẫn Lối)",
    "name": "Tiên Nhân Chỉ Lộ (Binh Khai Cuộc)",
    "cn": "仙人指路",
    "overview": "Nước cờ ném đá dò đường đầy mưu lược. Tiến Binh 3 hoặc Binh 7 mở thông lộ cho Mã, đồng thời quan sát ý đồ đối phương để chuyển sang Trung Pháo, Phi Tượng hoặc Khởi Mã.",
    "maxim": "Tiên Nhân Chỉ Lộ biến vô cùng, thăm dò ý địch chuyển thần thông.\nThốt để pháo sang phòng phế mã, kim câu pháo quấy khó thành công.\nNhìn xa trông rộng công toàn diện, chớp lấy thời cơ phá vỡ vòng!",
    "strategicKey": "Linh hoạt biến hóa tùy cơ ứng biến. Gặp Thốt Để Pháo chuyển Trung Pháo phế Mã tranh tiên cực kỳ hung hiểm.",
    "subtypes": [
      "Tiên Nhân Chỉ Lộ Đối Thốt Để Pháo",
      "Tiên Nhân Chỉ Lộ Đối Kim Câu Pháo",
      "Tiên Nhân Chỉ Lộ Chuyển Trung Pháo Phế Mã",
      "Đối Binh Cuộc (Song Binh Tương Tác)"
    ],
    "lessonCount": 79,
    "traps": [
      {
        "trapId": "featured_tien-nhan_1",
        "lessonId": "op_tien-nhan_1_b6182b",
        "name": "Tiên Nhân Chỉ Lộ Toàn Thư - Biến 1",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "炮２平３",
            "black_vi": "Pháo 2 bình 3"
          },
          {
            "num": 2,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "象３进５",
            "black_vi": "Tượng 3 tiến 5"
          },
          {
            "num": 3,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 4,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 5,
            "red": "马八进九",
            "red_vi": "Mã 8 tiến 9",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 6,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "车９平４",
            "black_vi": "Xe 9 bình 4"
          },
          {
            "num": 7,
            "red": "炮五进四",
            "red_vi": "Pháo 5 tiến 4",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          },
          {
            "num": 8,
            "red": "炮五平一",
            "red_vi": "Pháo 5 bình 1",
            "black": "马２进１",
            "black_vi": "Mã 2 tiến 1"
          },
          {
            "num": 9,
            "red": "炮一进三",
            "red_vi": "Pháo 1 tiến 3",
            "black": "马８进９",
            "black_vi": "Mã 8 tiến 9"
          },
          {
            "num": 10,
            "red": "炮八平五",
            "red_vi": "Pháo 8 bình 5",
            "black": "马１进３",
            "black_vi": "Mã 1 tiến 3"
          }
        ],
        "movesSummary": "1. 兵七进一 炮２平３ 2. 炮二平五 象３进５ 3. 马二进三 卒３进１ 4. 车一平二 卒３进１ 5. 马八进九 车９进１ 6. 车九平八 车９平４ 7. 炮五进四 士４进５",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_tien-nhan_2",
        "lessonId": "op_tien-nhan_2_e5dd57",
        "name": "Tiên Nhân Chỉ Lộ Toàn Thư - Biến 2",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "炮２平３",
            "black_vi": "Pháo 2 bình 3"
          },
          {
            "num": 2,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "象３进５",
            "black_vi": "Tượng 3 tiến 5"
          },
          {
            "num": 3,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 4,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 5,
            "red": "马八进九",
            "red_vi": "Mã 8 tiến 9",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 6,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "车９平４",
            "black_vi": "Xe 9 bình 4"
          },
          {
            "num": 7,
            "red": "炮五进四",
            "red_vi": "Pháo 5 tiến 4",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          },
          {
            "num": 8,
            "red": "炮五平一",
            "red_vi": "Pháo 5 bình 1",
            "black": "马２进１",
            "black_vi": "Mã 2 tiến 1"
          },
          {
            "num": 9,
            "red": "炮一进三",
            "red_vi": "Pháo 1 tiến 3",
            "black": "马８进９",
            "black_vi": "Mã 8 tiến 9"
          },
          {
            "num": 10,
            "red": "炮八平五",
            "red_vi": "Pháo 8 bình 5",
            "black": "马１进３",
            "black_vi": "Mã 1 tiến 3"
          }
        ],
        "movesSummary": "1. 兵七进一 炮２平３ 2. 炮二平五 象３进５ 3. 马二进三 卒３进１ 4. 车一平二 卒３进１ 5. 马八进九 车９进１ 6. 车九平八 车９平４ 7. 炮五进四 士４进５",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_tien-nhan_3",
        "lessonId": "op_tien-nhan_3_aa3c36",
        "name": "Tiên Nhân Chỉ Lộ Toàn Thư - Biến 3",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "炮２平３",
            "black_vi": "Pháo 2 bình 3"
          },
          {
            "num": 2,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "象３进５",
            "black_vi": "Tượng 3 tiến 5"
          },
          {
            "num": 3,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 4,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 5,
            "red": "马八进九",
            "red_vi": "Mã 8 tiến 9",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 6,
            "red": "车九平八",
            "red_vi": "Xe 9 bình 8",
            "black": "车９平４",
            "black_vi": "Xe 9 bình 4"
          },
          {
            "num": 7,
            "red": "炮五进四",
            "red_vi": "Pháo 5 tiến 4",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          },
          {
            "num": 8,
            "red": "炮五平一",
            "red_vi": "Pháo 5 bình 1",
            "black": "马２进１",
            "black_vi": "Mã 2 tiến 1"
          },
          {
            "num": 9,
            "red": "炮一进三",
            "red_vi": "Pháo 1 tiến 3",
            "black": "马８进９",
            "black_vi": "Mã 8 tiến 9"
          },
          {
            "num": 10,
            "red": "炮八平五",
            "red_vi": "Pháo 8 bình 5",
            "black": "马１进３",
            "black_vi": "Mã 1 tiến 3"
          }
        ],
        "movesSummary": "1. 兵七进一 炮２平３ 2. 炮二平五 象３进５ 3. 马二进三 卒３进１ 4. 车一平二 卒３进１ 5. 马八进九 车９进１ 6. 车九平八 车９平４ 7. 炮五进四 士４进５",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      }
    ]
  },
  {
    "id": "khoi-ma",
    "folder": "08. Khởi Mã Cuộc (Ẩn Long Xuất Hải)",
    "name": "Khởi Mã Cuộc (Mã Khai Đầu)",
    "cn": "起马局",
    "overview": "Lối chơi phòng ngự phản công kín kẽ, phong cách Đại Sư Dương Quan Lân. Mã lên sớm bảo vệ Tốt đầu, sau đó chuyển thành Tam Bộ Hổ hoặc Bình Phong Mã vững như bàn thạch.",
    "maxim": "Khởi Mã xuất chiêu ẩn tướng tài, Tam Bộ Hổ uy chấn trần ai.\nĐịch tham pháo giữa toan đè ép, mã quỳ nhảy chặn pháo tàn phai.\nCông thủ vẹn toàn như thiết thạch, hậu phát chế nhân định tương lai!",
    "strategicKey": "Nhử đối phương đem Pháo vào giữa, dùng Mã nhảy quỳ chặn ngòi, khóa chết đường công của địch.",
    "subtypes": [
      "Khởi Mã Chuyển Tam Bộ Hổ",
      "Khởi Mã Bẫy Bắt Pháo Hớ",
      "Khởi Mã Khóa Cánh Xe Mã"
    ],
    "lessonCount": 168,
    "traps": [
      {
        "trapId": "featured_khoi-ma_1",
        "lessonId": "op_khoi-ma_1_da7f82",
        "name": "Tuyệt Kỹ Phá Khởi Mã Cuộc - Biến 1",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 2,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 3,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "车１进１",
            "black_vi": "Xe 1 tiến 1"
          },
          {
            "num": 4,
            "red": "车一进一",
            "red_vi": "Xe 1 tiến 1",
            "black": "车１平７",
            "black_vi": "Xe 1 bình 7"
          },
          {
            "num": 5,
            "red": "炮八进四",
            "red_vi": "Pháo 8 tiến 4",
            "black": "马３进２",
            "black_vi": "Mã 3 tiến 2"
          },
          {
            "num": 6,
            "red": "马三进四",
            "red_vi": "Mã 3 tiến 4",
            "black": "象７进５",
            "black_vi": "Tượng 7 tiến 5"
          },
          {
            "num": 7,
            "red": "车九进一",
            "red_vi": "Xe 9 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 8,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "马８进６",
            "black_vi": "Mã 8 tiến 6"
          },
          {
            "num": 9,
            "red": "车一平三",
            "red_vi": "Xe 1 bình 3",
            "black": "马６进４",
            "black_vi": "Mã 6 tiến 4"
          },
          {
            "num": 10,
            "red": "炮八平七",
            "red_vi": "Pháo 8 bình 7",
            "black": "炮８平７",
            "black_vi": "Pháo 8 bình 7"
          }
        ],
        "movesSummary": "1. 马八进七 卒３进１ 2. 兵三进一 马２进３ 3. 马二进三 车１进１ 4. 车一进一 车１平７ 5. 炮八进四 马３进２ 6. 马三进四 象７进５ 7. 车九进一 卒７进１",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_khoi-ma_2",
        "lessonId": "op_khoi-ma_2_9d3b38",
        "name": "Tuyệt Kỹ Phá Khởi Mã Cuộc - Biến 2",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 2,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 3,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "车１进１",
            "black_vi": "Xe 1 tiến 1"
          },
          {
            "num": 4,
            "red": "车一进一",
            "red_vi": "Xe 1 tiến 1",
            "black": "车１平７",
            "black_vi": "Xe 1 bình 7"
          },
          {
            "num": 5,
            "red": "马三进四",
            "red_vi": "Mã 3 tiến 4",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 6,
            "red": "炮二平三",
            "red_vi": "Pháo 2 bình 3",
            "black": "马８进９",
            "black_vi": "Mã 8 tiến 9"
          },
          {
            "num": 7,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 8,
            "red": "车九进一",
            "red_vi": "Xe 9 tiến 1",
            "black": "象７进５",
            "black_vi": "Tượng 7 tiến 5"
          },
          {
            "num": 9,
            "red": "车九平六",
            "red_vi": "Xe 9 bình 6",
            "black": "炮８进５",
            "black_vi": "Pháo 8 tiến 5"
          },
          {
            "num": 10,
            "red": "马四退五",
            "red_vi": "Mã 4 thoái 5",
            "black": "车７平８",
            "black_vi": "Xe 7 bình 8"
          }
        ],
        "movesSummary": "1. 马八进七 卒３进１ 2. 兵三进一 马２进３ 3. 马二进三 车１进１ 4. 车一进一 车１平７ 5. 马三进四 卒７进１ 6. 炮二平三 马８进９ 7. 车一平二 车９平８",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_khoi-ma_3",
        "lessonId": "op_khoi-ma_3_f8a8fc",
        "name": "Tuyệt Kỹ Phá Khởi Mã Cuộc - Biến 3",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "卒３进１",
            "black_vi": "Tốt 3 tiến 1"
          },
          {
            "num": 2,
            "red": "兵三进一",
            "red_vi": "Binh 3 tiến 1",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 3,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "车１进１",
            "black_vi": "Xe 1 tiến 1"
          },
          {
            "num": 4,
            "red": "车一进一",
            "red_vi": "Xe 1 tiến 1",
            "black": "车１平７",
            "black_vi": "Xe 1 bình 7"
          },
          {
            "num": 5,
            "red": "马三进四",
            "red_vi": "Mã 3 tiến 4",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 6,
            "red": "炮二平三",
            "red_vi": "Pháo 2 bình 3",
            "black": "马８进９",
            "black_vi": "Mã 8 tiến 9"
          },
          {
            "num": 7,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 8,
            "red": "车九进一",
            "red_vi": "Xe 9 tiến 1",
            "black": "象７进５",
            "black_vi": "Tượng 7 tiến 5"
          },
          {
            "num": 9,
            "red": "车九平六",
            "red_vi": "Xe 9 bình 6",
            "black": "炮８进５",
            "black_vi": "Pháo 8 tiến 5"
          },
          {
            "num": 10,
            "red": "马四退五",
            "red_vi": "Mã 4 thoái 5",
            "black": "车７平８",
            "black_vi": "Xe 7 bình 8"
          }
        ],
        "movesSummary": "1. 马八进七 卒３进１ 2. 兵三进一 马２进３ 3. 马二进三 车１进１ 4. 车一进一 车１平７ 5. 马三进四 卒７进１ 6. 炮二平三 马８进９ 7. 车一平二 车９平８",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      }
    ]
  },
  {
    "id": "qua-cung-si-giac",
    "folder": "09. Quá Cung Pháo & Sĩ Giác Pháo (Kỳ Binh Dị Lộ)",
    "name": "Quá Cung Pháo & Sĩ Giác Pháo",
    "cn": "过宫炮与士角炮",
    "overview": "Hai thế trận kỳ binh khéo léo. Quá Cung Pháo tập trung hỏa lực đánh lệch sườn đối phương. Sĩ Giác Pháo vừa giữ trung tâm vừa bảo vệ Tượng, công thủ toàn diện.",
    "maxim": "Quá Cung Pháo dời thế hiểm sâu, tập trung hỏa lực đánh một đầu.\nSĩ Giác phòng thủ linh hoạt biến, chuyển thành thế công chiếm đỉnh cao.\nKhéo léo điều quân lừa địch hở, bắt quân đoạt lợi thắng mau mau!",
    "strategicKey": "Dồn quân ép vào cánh yếu của đối phương, phong tỏa lộ xuất Xe của địch.",
    "subtypes": [
      "Quá Cung Pháo Giăng Lưới Song Pháo",
      "Sĩ Giác Pháo Chuyển Trận Khắc Pháo Đầu",
      "Quá Cung Pháo Bẫy Ép Xe Vào Tử Lộ"
    ],
    "lessonCount": 76,
    "traps": [
      {
        "trapId": "featured_qua-cung-si-giac_1",
        "lessonId": "op_qua-cung-si-giac_1_48e0b6",
        "name": "Tuyệt Kỹ Phá Quá Cung Pháo - Biến 1",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平六",
            "red_vi": "Pháo 2 bình 6",
            "black": "炮８平５",
            "black_vi": "Pháo 8 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 4,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "车９平４",
            "black_vi": "Xe 9 bình 4"
          },
          {
            "num": 5,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 6,
            "red": "车二进四",
            "red_vi": "Xe 2 tiến 4",
            "black": "车４进５",
            "black_vi": "Xe 4 tiến 5"
          },
          {
            "num": 7,
            "red": "炮六平四",
            "red_vi": "Pháo 6 bình 4",
            "black": "卒５进１",
            "black_vi": "Tốt 5 tiến 1"
          },
          {
            "num": 8,
            "red": "仕六进五",
            "red_vi": "Sĩ 6 tiến 5",
            "black": "车１进１",
            "black_vi": "Xe 1 tiến 1"
          },
          {
            "num": 9,
            "red": "相七进五",
            "red_vi": "Tượng 7 tiến 5",
            "black": "车１平６",
            "black_vi": "Xe 1 bình 6"
          },
          {
            "num": 10,
            "red": "车九平六",
            "red_vi": "Xe 9 bình 6",
            "black": "车４进３",
            "black_vi": "Xe 4 tiến 3"
          }
        ],
        "movesSummary": "1. 炮二平六 炮８平５ 2. 马二进三 马８进７ 3. 车一平二 车９进１ 4. 马八进七 车９平４ 5. 兵七进一 马２进３ 6. 车二进四 车４进５ 7. 炮六平四 卒５进１",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_qua-cung-si-giac_2",
        "lessonId": "op_qua-cung-si-giac_2_dd8620",
        "name": "Tuyệt Kỹ Phá Quá Cung Pháo - Biến 2",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平六",
            "red_vi": "Pháo 2 bình 6",
            "black": "炮８平５",
            "black_vi": "Pháo 8 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 4,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "车９平４",
            "black_vi": "Xe 9 bình 4"
          },
          {
            "num": 5,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 6,
            "red": "车二进四",
            "red_vi": "Xe 2 tiến 4",
            "black": "车４进５",
            "black_vi": "Xe 4 tiến 5"
          },
          {
            "num": 7,
            "red": "炮六平四",
            "red_vi": "Pháo 6 bình 4",
            "black": "卒５进１",
            "black_vi": "Tốt 5 tiến 1"
          },
          {
            "num": 8,
            "red": "仕六进五",
            "red_vi": "Sĩ 6 tiến 5",
            "black": "车１进１",
            "black_vi": "Xe 1 tiến 1"
          },
          {
            "num": 9,
            "red": "相七进五",
            "red_vi": "Tượng 7 tiến 5",
            "black": "车１平６",
            "black_vi": "Xe 1 bình 6"
          },
          {
            "num": 10,
            "red": "炮八进四",
            "red_vi": "Pháo 8 tiến 4",
            "black": "卒５进１",
            "black_vi": "Tốt 5 tiến 1"
          }
        ],
        "movesSummary": "1. 炮二平六 炮８平５ 2. 马二进三 马８进７ 3. 车一平二 车９进１ 4. 马八进七 车９平４ 5. 兵七进一 马２进３ 6. 车二进四 车４进５ 7. 炮六平四 卒５进１",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_qua-cung-si-giac_3",
        "lessonId": "op_qua-cung-si-giac_3_8a55e7",
        "name": "Tuyệt Kỹ Phá Quá Cung Pháo - Biến 3",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平六",
            "red_vi": "Pháo 2 bình 6",
            "black": "炮８平５",
            "black_vi": "Pháo 8 bình 5"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 4,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "车９平４",
            "black_vi": "Xe 9 bình 4"
          },
          {
            "num": 5,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 6,
            "red": "车二进四",
            "red_vi": "Xe 2 tiến 4",
            "black": "车４进５",
            "black_vi": "Xe 4 tiến 5"
          },
          {
            "num": 7,
            "red": "炮六平四",
            "red_vi": "Pháo 6 bình 4",
            "black": "卒５进１",
            "black_vi": "Tốt 5 tiến 1"
          },
          {
            "num": 8,
            "red": "仕六进五",
            "red_vi": "Sĩ 6 tiến 5",
            "black": "车１进１",
            "black_vi": "Xe 1 tiến 1"
          },
          {
            "num": 9,
            "red": "相七进五",
            "red_vi": "Tượng 7 tiến 5",
            "black": "车１平６",
            "black_vi": "Xe 1 bình 6"
          },
          {
            "num": 10,
            "red": "炮八进四",
            "red_vi": "Pháo 8 tiến 4",
            "black": "卒５进１",
            "black_vi": "Tốt 5 tiến 1"
          }
        ],
        "movesSummary": "1. 炮二平六 炮８平５ 2. 马二进三 马８进７ 3. 车一平二 车９进１ 4. 马八进七 车９平４ 5. 兵七进一 马２进３ 6. 车二进四 车４进５ 7. 炮六平四 卒５进１",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      }
    ]
  },
  {
    "id": "giang-ho-di-cuoc",
    "folder": "10. Dị Cuộc & Phi Đao Giang Hồ (Cạm Bẫy Độc Hiểm Nhất)",
    "name": "Dị Cuộc & Phi Đao Giang Hồ",
    "cn": "江湖飞刀与异型局",
    "overview": "Kho tàng các thế trận phi đao, dị thế giang hồ độc hiểm nhất. Thí Xe ngay nước đầu (Thiết Hoạt Xa), rút Pháo lưng rùa (Quy Bối Pháo), Song Pháo kẹp cánh (Uyên Ương Pháo), và các thế bẫy chết Xe kinh điển.",
    "maxim": "Giang hồ phi đao dị cuộc kỳ, Thiết Hoạt phế xe bước hiểm nguy.\nQuy Bối pháo lui chờ sấm chớp, Uyên Ương pháo cặp bắt xe đi.\nGặp bẫy bình tâm tra cội rễ, chớ tham ăn nhỏ họa tức thì!",
    "strategicKey": "Những thế cờ này thường phế quân lớn để giành quyền chủ động tuyệt đối. Nếu đối phương tham ăn mà không tính sâu sẽ dính đòn sát cục chỉ trong 5-10 nước.",
    "subtypes": [
      "Thiết Hoạt Xa Phế Xe Đoạt Thế Thần Tốc",
      "Quy Bối Pháo (Pháo Lưng Rùa)",
      "Uyên Ương Pháo Bắt Xe Độc Hiểm",
      "Tuyển Tập Bẫy Chết Xe Cổ Điển & Hiện Đại"
    ],
    "lessonCount": 94,
    "traps": [
      {
        "trapId": "featured_giang-ho-di-cuoc_1",
        "lessonId": "op_giang-ho-di-cuoc_1_a685cd",
        "name": "Đối Binh Cuộc Khởi Thế Bình Ổn - Biến 1",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 2,
            "red": "相三进五",
            "red_vi": "Tượng 3 tiến 5",
            "black": "象３进５",
            "black_vi": "Tượng 3 tiến 5"
          },
          {
            "num": 3,
            "red": "马二进四",
            "red_vi": "Mã 2 tiến 4",
            "black": "马２进４",
            "black_vi": "Mã 2 tiến 4"
          },
          {
            "num": 4,
            "red": "车一平三",
            "red_vi": "Xe 1 bình 3",
            "black": "炮８平７",
            "black_vi": "Pháo 8 bình 7"
          },
          {
            "num": 5,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "车１平３",
            "black_vi": "Xe 1 bình 3"
          },
          {
            "num": 6,
            "red": "马七进六",
            "red_vi": "Mã 7 tiến 6",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 7,
            "red": "炮二平三",
            "red_vi": "Pháo 2 bình 3",
            "black": "车９平６",
            "black_vi": "Xe 9 bình 6"
          },
          {
            "num": 8,
            "red": "马四进六",
            "red_vi": "Mã 4 tiến 6",
            "black": "炮２进３",
            "black_vi": "Pháo 2 tiến 3"
          },
          {
            "num": 9,
            "red": "前马退七",
            "red_vi": "Tiền Mã thoái 7",
            "black": "炮２退３",
            "black_vi": "Pháo 2 thoái 3"
          },
          {
            "num": 10,
            "red": "车三平二",
            "red_vi": "Xe 3 bình 2",
            "black": "马８进９",
            "black_vi": "Mã 8 tiến 9"
          }
        ],
        "movesSummary": "1. 兵七进一 卒７进１ 2. 相三进五 象３进５ 3. 马二进四 马２进４ 4. 车一平三 炮８平７ 5. 马八进七 车１平３ 6. 马七进六 车９进１ 7. 炮二平三 车９平６",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_giang-ho-di-cuoc_2",
        "lessonId": "op_giang-ho-di-cuoc_2_5becb1",
        "name": "Đối Binh Cuộc Khởi Thế Bình Ổn - Biến 2",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 2,
            "red": "相三进五",
            "red_vi": "Tượng 3 tiến 5",
            "black": "象３进５",
            "black_vi": "Tượng 3 tiến 5"
          },
          {
            "num": 3,
            "red": "马二进四",
            "red_vi": "Mã 2 tiến 4",
            "black": "马２进４",
            "black_vi": "Mã 2 tiến 4"
          },
          {
            "num": 4,
            "red": "车一平三",
            "red_vi": "Xe 1 bình 3",
            "black": "炮８平７",
            "black_vi": "Pháo 8 bình 7"
          },
          {
            "num": 5,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "车１平３",
            "black_vi": "Xe 1 bình 3"
          },
          {
            "num": 6,
            "red": "马七进六",
            "red_vi": "Mã 7 tiến 6",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 7,
            "red": "炮二平三",
            "red_vi": "Pháo 2 bình 3",
            "black": "车９平６",
            "black_vi": "Xe 9 bình 6"
          },
          {
            "num": 8,
            "red": "马四进六",
            "red_vi": "Mã 4 tiến 6",
            "black": "炮２进３",
            "black_vi": "Pháo 2 tiến 3"
          },
          {
            "num": 9,
            "red": "前马退七",
            "red_vi": "Tiền Mã thoái 7",
            "black": "炮２退３",
            "black_vi": "Pháo 2 thoái 3"
          },
          {
            "num": 10,
            "red": "车三平二",
            "red_vi": "Xe 3 bình 2",
            "black": "马８进９",
            "black_vi": "Mã 8 tiến 9"
          }
        ],
        "movesSummary": "1. 兵七进一 卒７进１ 2. 相三进五 象３进５ 3. 马二进四 马２进４ 4. 车一平三 炮８平７ 5. 马八进七 车１平３ 6. 马七进六 车９进１ 7. 炮二平三 车９平６",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_giang-ho-di-cuoc_3",
        "lessonId": "op_giang-ho-di-cuoc_3_06e56a",
        "name": "Đối Binh Cuộc Khởi Thế Bình Ổn - Biến 3",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 2,
            "red": "相三进五",
            "red_vi": "Tượng 3 tiến 5",
            "black": "象３进５",
            "black_vi": "Tượng 3 tiến 5"
          },
          {
            "num": 3,
            "red": "马二进四",
            "red_vi": "Mã 2 tiến 4",
            "black": "马２进４",
            "black_vi": "Mã 2 tiến 4"
          },
          {
            "num": 4,
            "red": "车一平三",
            "red_vi": "Xe 1 bình 3",
            "black": "炮８平７",
            "black_vi": "Pháo 8 bình 7"
          },
          {
            "num": 5,
            "red": "马八进七",
            "red_vi": "Mã 8 tiến 7",
            "black": "车１平３",
            "black_vi": "Xe 1 bình 3"
          },
          {
            "num": 6,
            "red": "马七进六",
            "red_vi": "Mã 7 tiến 6",
            "black": "车９进１",
            "black_vi": "Xe 9 tiến 1"
          },
          {
            "num": 7,
            "red": "炮二平三",
            "red_vi": "Pháo 2 bình 3",
            "black": "车９平６",
            "black_vi": "Xe 9 bình 6"
          },
          {
            "num": 8,
            "red": "马四进六",
            "red_vi": "Mã 4 tiến 6",
            "black": "炮２进３",
            "black_vi": "Pháo 2 tiến 3"
          },
          {
            "num": 9,
            "red": "前马退七",
            "red_vi": "Tiền Mã thoái 7",
            "black": "炮２退３",
            "black_vi": "Pháo 2 thoái 3"
          },
          {
            "num": 10,
            "red": "车三平二",
            "red_vi": "Xe 3 bình 2",
            "black": "马８进９",
            "black_vi": "Mã 8 tiến 9"
          }
        ],
        "movesSummary": "1. 兵七进一 卒７进１ 2. 相三进五 象３进５ 3. 马二进四 马２进４ 4. 车一平三 炮８平７ 5. 马八进七 车１平３ 6. 马七进六 车９进１ 7. 炮二平三 车９平６",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      }
    ]
  },
  {
    "id": "phe-quan-dinh-cao",
    "folder": "11. Chuyên Đề Phế Quân Đỉnh Cao (Khí Tử Tranh Tiên)",
    "name": "Khai Cục Phế Quân Đỉnh Cao (Khí Tử Tranh Tiên)",
    "cn": "开局弃子争先局",
    "overview": "Đỉnh cao nghệ thuật thí quân đoạt thế trong cờ tướng. Dám bỏ Mã, bỏ Pháo, thậm chí bỏ Xe ngay từ khai cuộc để đổi lấy tốc độ xuất quân thần tốc, phá tan sĩ tượng, đoạt quyền chủ động và dứt điểm đối phương trong chớp mắt.",
    "maxim": "Khí mã tranh tiên tốc độ cao, phong xa hãm trận đoạt kỳ hào.\nPhế quân tất hữu liên hoàn kế, xuất kỳ bất ý sát cửu cung!\nDĩ thời đoạt thế, dĩ không gian chế nhân!",
    "strategicKey": "Quy tắc hoàng kim phế quân: Bỏ trước đoạt sau, thời gian quý hơn lực lượng, mỗi nước đi sau khi phế quân phải là đòn ép buộc hoặc dọa sát liên hoàn.",
    "subtypes": [
      "Khí Mã Thập Tam Trứ (Quất Trung Bí)",
      "Bình Phong Mã Phế Mã Đoạt Tiên (弃马争先)",
      "Tiên Nhân Chỉ Lộ Phế Mã Phá Trận",
      "Thiết Hoạt Xa Phế Xe Đoạt Tiên Thần Tốc",
      "Trung Pháo Cấp Tiến Phế Quân",
      "Thuận Pháo Khí Pháo Khai Lộ Xe",
      "Quy Bối Pháo Khí Tử Nghịch Chuyển",
      "Thí Quân Sát Cục Đại Sư (Hồ Vinh Hoa, Hứa Ngân Xuyên...)"
    ],
    "lessonCount": 363,
    "traps": [
      {
        "trapId": "featured_phe-quan-dinh-cao_1",
        "lessonId": "op_phe-quan-dinh-cao_1_f66f24",
        "name": "Trung Pháo Cấp Tấn Trung Binh Khí Mã - Biến 1",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 4,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 5,
            "red": "车二进六",
            "red_vi": "Xe 2 tiến 6",
            "black": "炮８平９",
            "black_vi": "Pháo 8 bình 9"
          },
          {
            "num": 6,
            "red": "车二平三",
            "red_vi": "Xe 2 bình 3",
            "black": "炮９退１",
            "black_vi": "Pháo 9 thoái 1"
          },
          {
            "num": 7,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          },
          {
            "num": 8,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "炮９平７",
            "black_vi": "Pháo 9 bình 7"
          },
          {
            "num": 9,
            "red": "车三平四",
            "red_vi": "Xe 3 bình 4",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 10,
            "red": "马三进五",
            "red_vi": "Mã 3 tiến 5",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          }
        ],
        "movesSummary": "1. 炮二平五 马８进７ 2. 马二进三 车９平８ 3. 车一平二 马２进３ 4. 兵七进一 卒７进１ 5. 车二进六 炮８平９ 6. 车二平三 炮９退１ 7. 兵五进一 士４进５",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_phe-quan-dinh-cao_2",
        "lessonId": "op_phe-quan-dinh-cao_2_fda6c7",
        "name": "Trung Pháo Cấp Tấn Trung Binh Khí Mã - Biến 2",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 4,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 5,
            "red": "车二进六",
            "red_vi": "Xe 2 tiến 6",
            "black": "炮８平９",
            "black_vi": "Pháo 8 bình 9"
          },
          {
            "num": 6,
            "red": "车二平三",
            "red_vi": "Xe 2 bình 3",
            "black": "炮９退１",
            "black_vi": "Pháo 9 thoái 1"
          },
          {
            "num": 7,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          },
          {
            "num": 8,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "炮９平７",
            "black_vi": "Pháo 9 bình 7"
          },
          {
            "num": 9,
            "red": "车三平四",
            "red_vi": "Xe 3 bình 4",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 10,
            "red": "马三进五",
            "red_vi": "Mã 3 tiến 5",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          }
        ],
        "movesSummary": "1. 炮二平五 马８进７ 2. 马二进三 车９平８ 3. 车一平二 马２进３ 4. 兵七进一 卒７进１ 5. 车二进六 炮８平９ 6. 车二平三 炮９退１ 7. 兵五进一 士４进５",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      },
      {
        "trapId": "featured_phe-quan-dinh-cao_3",
        "lessonId": "op_phe-quan-dinh-cao_3_1db10c",
        "name": "Trung Pháo Cấp Tấn Trung Binh Khí Mã - Biến 3",
        "fen": "rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR w - - 0 1",
        "moves": [
          {
            "num": 1,
            "red": "炮二平五",
            "red_vi": "Pháo 2 bình 5",
            "black": "马８进７",
            "black_vi": "Mã 8 tiến 7"
          },
          {
            "num": 2,
            "red": "马二进三",
            "red_vi": "Mã 2 tiến 3",
            "black": "车９平８",
            "black_vi": "Xe 9 bình 8"
          },
          {
            "num": 3,
            "red": "车一平二",
            "red_vi": "Xe 1 bình 2",
            "black": "马２进３",
            "black_vi": "Mã 2 tiến 3"
          },
          {
            "num": 4,
            "red": "兵七进一",
            "red_vi": "Binh 7 tiến 1",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 5,
            "red": "车二进六",
            "red_vi": "Xe 2 tiến 6",
            "black": "炮８平９",
            "black_vi": "Pháo 8 bình 9"
          },
          {
            "num": 6,
            "red": "车二平三",
            "red_vi": "Xe 2 bình 3",
            "black": "炮９退１",
            "black_vi": "Pháo 9 thoái 1"
          },
          {
            "num": 7,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "士４进５",
            "black_vi": "Sĩ 4 tiến 5"
          },
          {
            "num": 8,
            "red": "兵五进一",
            "red_vi": "Binh 5 tiến 1",
            "black": "炮９平７",
            "black_vi": "Pháo 9 bình 7"
          },
          {
            "num": 9,
            "red": "车三平四",
            "red_vi": "Xe 3 bình 4",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          },
          {
            "num": 10,
            "red": "马三进五",
            "red_vi": "Mã 3 tiến 5",
            "black": "卒７进１",
            "black_vi": "Tốt 7 tiến 1"
          }
        ],
        "movesSummary": "1. 炮二平五 马８进７ 2. 马二进三 车９平８ 3. 车一平二 马２进３ 4. 兵七进一 卒７进１ 5. 车二进六 炮８平９ 6. 车二平三 炮９退１ 7. 兵五进一 士４进５",
        "bait": "Chủ động điều quân nhử đối phương xuất quân lệch nhịp hoặc tham ăn quân nhỏ.",
        "blunder": "Nôn nóng xông Xe hoặc ăn quân làm gãy trận hình phòng ngự.",
        "punishment": "Khai thác điểm yếu trung lộ hoặc sườn hở để phản công đoạt thế áp đảo.",
        "refutation": "Triển khai quân bài bản theo khẩu quyết đại sư, củng cố trung cung vững chắc."
      }
    ]
  }
];

export default OPENING_TRAP_MASTER_DATABASE;
